import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import PublicJobCard from "../components/PublicJobCard";
import PublicLayout from "../components/PublicLayout";

const ROLE_ICONS = ["⌘", "◉", "↗", "▦", "✦", "+"];

const PublicHome = () => {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [location, setLocation] = useState("");
  const [jobs, setJobs] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    Promise.all([
      axiosInstance.get("/job-portal/jobs/public?limit=4&sort=newest"),
      axiosInstance.get("/get-all-specialization"),
    ]).then(([jobResponse, categoryResponse]) => {
      setJobs(jobResponse.data?.data?.jobs || []);
      setCategories((categoryResponse.data?.Specialization || []).slice(0, 4));
    }).catch(() => {});
  }, []);

  const search = (event) => {
    event.preventDefault();
    const params = new URLSearchParams();
    if (keyword) params.set("search", keyword);
    if (location) params.set("location", location);
    navigate(`/jobs${params.toString() ? `?${params}` : ""}`);
  };

  const roleCards = categories.length ? categories : [
    { name: "Technology" }, { name: "Design" }, { name: "Sales" }, { name: "Healthcare" },
  ];

  return (
    <PublicLayout>
      <Helmet><title>Ynbjobs | Find work that actually fits you</title></Helmet>

      <section className="ynb-home-hero">
        <div className="portal-container ynb-home-grid">
          <div>
            <div className="ynb-eyebrow">AI-powered hiring · India · Global</div>
            <h1>Find work that <span>actually fits you.</span></h1>
            <p>Match with opportunities using your real skills, experience, timing, and goals—not empty buzzwords.</p>
            <form className="ynb-hero-search" onSubmit={search}>
              <label><i className="ri-search-line"></i><input value={keyword} onChange={(e) => setKeyword(e.target.value)} placeholder="Job title, skill or company" /></label>
              <label><i className="ri-map-pin-line"></i><input value={location} onChange={(e) => setLocation(e.target.value)} placeholder="Location or Remote" /></label>
              <button type="submit">Search jobs <span>→</span></button>
            </form>
            <div className="ynb-quick-links"><span>Popular:</span><Link to="/jobs?workMode=remote">Remote</Link><Link to="/jobs?sort=newest">Urgent hiring</Link><Link to="/jobs?experienceMin=0">Freshers</Link></div>
          </div>

          <div className="ynb-hero-visual" aria-label="AI job matching preview">
            <div className="ynb-visual-top"><span>Talent match</span><span className="ynb-live-dot">Live</span></div>
            <div className="ynb-candidate-row"><div className="ynb-avatar">AR</div><div><strong>Alex Rivers</strong><small>Senior Product Designer</small></div><b>92%</b></div>
            <div className="ynb-skill-bars"><span style={{ width: "92%" }}></span><span style={{ width: "78%" }}></span><span style={{ width: "86%" }}></span></div>
            <div className="ynb-match-card"><span>✦ AI match score</span><strong>92%</strong><small>Excellent fit for this role</small></div>
          </div>
        </div>
      </section>

      <section className="ynb-section">
        <div className="portal-container">
          <div className="ynb-section-heading"><div><span>Explore opportunities</span><h2>Popular roles</h2></div><Link to="/jobs">View all roles →</Link></div>
          <div className="ynb-role-grid">
            {roleCards.map((role, index) => <Link to={`/jobs?department=${encodeURIComponent(role.name)}`} className={index === 1 ? "featured" : ""} key={role.id || role.name}><i>{ROLE_ICONS[index]}</i><strong>{role.name}</strong><small>{index === 1 ? "850+" : `${430 + index * 270}+`} openings</small></Link>)}
          </div>
        </div>
      </section>

      <section className="ynb-section ynb-section-soft">
        <div className="portal-container">
          <div className="ynb-section-heading"><div><span>Curated for you</span><h2>Featured opportunities</h2><p>Fresh roles from teams hiring right now.</p></div><Link to="/jobs">View all jobs →</Link></div>
          {jobs.length ? <div className="ynb-featured-grid">{jobs.map((job) => <PublicJobCard job={job} key={job.id} />)}</div> : <div className="ynb-empty-card">New opportunities are being prepared. <Link to="/jobs">Browse all jobs</Link></div>}
        </div>
      </section>

      <section className="ynb-section">
        <div className="portal-container">
          <div className="ynb-ai-panel">
            <div><span className="ynb-ai-pill">✦ New AI features</span><h2>Master your career with AI.</h2><p>Score your resume, understand skill gaps, and discover roles where your experience has real value.</p><div className="ynb-ai-actions"><Link to="/register">Build my profile</Link><Link to="/jobs">Explore matches</Link></div></div>
            <div className="ynb-score-widget"><small>Resume score</small><strong>82<span>/100</span></strong><div><i></i></div><p>Great foundation · 3 quick improvements</p></div>
            <div className="ynb-gap-widget"><small>Skill readiness</small><strong>8/10</strong><p><span>●</span> React.js</p><p><span>●</span> Product thinking</p><p className="missing"><span>●</span> AI workflows</p></div>
          </div>
        </div>
      </section>

      <section className="ynb-section ynb-cta-wrap"><div className="portal-container"><div className="ynb-home-cta"><span>Ready for what’s next?</span><h2>Build a career that moves with you.</h2><Link to="/register">Start your journey</Link></div></div></section>
    </PublicLayout>
  );
};

export default PublicHome;
